"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _createStyled = _interopRequireWildcard(require("../../../utils/createStyled"));

var _style = _interopRequireDefault(require("../style"));

var _variables = require("../variables");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject(), function (props) {
  return props.animation;
});

function template() {
  var styles = this.compileStyled(_style["default"]),
      _this$props = this.props,
      open = _this$props.open,
      message = _this$props.message,
      height = _this$props.height,
      bottom = _this$props.bottom,
      offset = _this$props.offset,
      onMoveEnd = _this$props.onMoveEnd,
      onHideEnd = _this$props.onHideEnd,
      render = _this$props.render,
      closeAvailable = _this$props.closeAvailable,
      theme = _this$props.theme,
      offsetKey = bottom ? _variables.BOTTOM : _variables.TOP;
  var content = null,
      animation = '';

  if (height) {
    animation = open ? styles.animationShow : styles.animationHide;
  }

  if (typeof render === 'function') {
    content = render(this.close);
  } else if (message) {
    content = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.contentWrapper
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.content
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.icon
    }), message), closeAvailable ? _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.closeWrapper
    }, _react["default"].createElement(_IconButton["default"], {
      onClick: this.close,
      iconFx: false,
      icon: theme.closeIcon
    })) : null);
  }

  return _react["default"].createElement(Root, {
    ref: this.ref,
    animation: animation,
    styles: styles.root,
    onTransitionEnd: onMoveEnd,
    onAnimationEnd: open ? null : onHideEnd,
    style: (0, _defineProperty2["default"])({}, offsetKey, offset)
  }, content);
}